export default {
    your_account: "您的账户无法确认",
    wait_while: "请稍等，我们确认您的帐户",
    the_code: "链接中的代码无效。",
    back_settings: "返回设置界面",
};
